import type { FormattedProductData } from 'reducers/detail/productDetail';

export interface LaunchCalendarProductInfo {
  productId: number;
  relatedStyles: LaunchCalendarCardStyleInfo[];
}

export interface LaunchCalendarCardStyleInfo {
  productId: number;
  productName: string;
  brandId: number;
  brandName: string;
  styleId: number;
  colorId: number;
  colorName: string;
  imageId?: string;
  hardLaunchDate: number;
  goLiveDate?: number;
}

export interface LaunchCalendarUpcomingStyles {
  [key: string]: LaunchCalendarProductInfo[];
}

export interface LaunchCalendarRecentLaunches {
  [key: string]: LaunchCalendarProductInfo[];
}

export interface UpcomingStylesQuickViewData {
  [productId: string]: FormattedProductData;
}

export enum LaunchCalendarSectionType {
  TODAYS_RELEASES,
  UPCOMING_RELEASES,
  RECENT_LAUNCHES
}

export enum LaunchCalendarTabs {
  UPCOMING,
  RECENTLY_LAUNCHED
}
